import type { Division } from "@/lib/types/deck-builder";
import { Deck } from "@/lib/classes/deck";
import type { DeckStringOptions } from "@/lib/classes/deck";
import type { UnitMap } from "@/lib/types/deck-builder";

export interface ParsedDeckInfo {
  divisionDescriptor: string;
  divisionName: string;
  isValid: boolean;
  error?: string;
}

/**
 * Parse deck code to extract division information
 */
export async function parseDeckCode(
  deckCode: string,
  divisions: Division[],
  unitMap: UnitMap
): Promise<ParsedDeckInfo> {
  try {
    const options: DeckStringOptions = {
      unitMap,
      divisions,
    };

    const deck = Deck.fromDeckCode(deckCode, options);
    
    return {
      divisionDescriptor: deck.division.descriptor,
      divisionName: deck.division.name,
      isValid: true,
    };
  } catch (error) {
    return {
      divisionDescriptor: "",
      divisionName: "",
      isValid: false,
      error: error instanceof Error ? error.message : "Failed to parse deck code",
    };
  }
}

/**
 * Format deck name for non-verified users
 */
export function formatDeckName(discordUsername: string, divisionName: string): string {
  return `${discordUsername}'s ${divisionName}`;
}

/**
 * Copy deck code to clipboard
 */
export async function copyDeckCodeToClipboard(code: string): Promise<void> {
  try {
    await navigator.clipboard.writeText(code);
  } catch (error) {
    console.error("Failed to copy deck code:", error);
    throw new Error("Failed to copy deck code to clipboard");
  }
}

/**
 * Generate a shareable URL for a deck code
 */
export function getDeckShareUrl(deckCode: string): string {
  return `${window.location.origin}/deck-builder?code=${encodeURIComponent(deckCode)}`;
}

/**
 * Copy deck share URL to clipboard
 */
export async function copyDeckShareUrl(deckCode: string): Promise<void> {
  try {
    const shareUrl = getDeckShareUrl(deckCode);
    await navigator.clipboard.writeText(shareUrl);
  } catch (error) {
    console.error("Failed to copy share URL:", error);
    throw new Error("Failed to copy share URL to clipboard");
  }
}









